// EcoLunch - Modele Financier v4.0 — COURBE PROGRESSIVE
// 10 provinces | Croissance mensuelle | Boost de rentree | Sezzle uplift
// Pre-launch (Jun-Aug 2026) + Y1-Y5 (Sept 2026 - Aout 2031)

export const ENFANTS_PAR_PARENT = 1.6;
export const CHECK_PAR_PARENT = 2.2;
export const APP_PRIX = 2; // Subscription parent optionnelle: 2$/mois (gross)
export const APP_DONATION_RATE = 0.5; // 50% reverse aux ecoles en don
export const APP_PRIX_NET = APP_PRIX * (1 - APP_DONATION_RATE); // Net pour EcoLunch: 1$/mois
export const JOURS_MOIS_SCOL = 18;
const JOURS_ETE_MOIS = 20;
export const SEZZLE_NET = 0.02;
export const TRAITEURS_INIT = 22;
export const SAAS_PRIX = 500;

// Taux par année (pour affichage dynamique dans les pages)
export const tauxParAnnee = {
  Y1: { ftRate: 0.015, ftFee: 0.15, sezzleUp: 0.18, appTx: 0.25, prix: 7.25 },
  Y2: { ftRate: 0.0218, ftFee: 0.18, sezzleUp: 0.20, appTx: 0.35, prix: 7.50 },
  Y3: { ftRate: 0.0237, ftFee: 0.18, sezzleUp: 0.20, appTx: 0.45, prix: 7.75 },
  Y4: { ftRate: 0.0243, ftFee: 0.20, sezzleUp: 0.20, appTx: 0.55, prix: 8.00 },
  Y5: { ftRate: 0.0246, ftFee: 0.20, sezzleUp: 0.25, appTx: 0.60, prix: 8.00 },
};

// ========== TAM 10 PROVINCES ==========
export const tamData = {
  qc: { public: 2000, prive: 240, total: 2240 },
  on: { public: 4000, prive: 800, total: 4800 },
  ab: { public: 2000, prive: 160, total: 2160 },
  bc: { public: 1600, prive: 250, total: 1850 },
  mb: { public: 500, prive: 40, total: 540 },
  sk: { public: 380, prive: 25, total: 405 },
  nb: { public: 200, prive: 20, total: 220 },
  ne: { public: 250, prive: 25, total: 275 },
  tnl: { public: 165, prive: 10, total: 175 },
  ipe: { public: 35, prive: 5, total: 40 },
};
export const TAM_TOTAL = 12705;

const EPE = { qc: 350, on: 350, ab: 350, bc: 350, mb: 305, sk: 200, nb: 275, ne: 286, tnl: 200, ipe: 343, prive: 350 };

// ========== YEAR CONFIGS (start/end of school year per province) ==========
const YEARS = {
  Y1: {
    startYear: 2026, prix: 7.25, sezzleUp: 0.18, appTx: 0.25,
    ft: { rate: 0.015, fee: 0.15 }, opex: 245000, traitRatio: 9,
    campRepas: 300, campPrix: 7.50,
    prov: {
      qc: { s: 200, e: 450, ps: 0.10, pe: 0.15 },
    }
  },
  Y2: {
    startYear: 2027, prix: 7.50, sezzleUp: 0.20, appTx: 0.35,
    ft: { rate: 0.0218, fee: 0.184 }, opex: 512000, traitRatio: 12,
    campRepas: 950, campPrix: 7.75,
    prov: {
      qc: { s: 450, e: 750, ps: 0.15, pe: 0.20 },
      on: { s: 150, e: 500, ps: 0.08, pe: 0.12 },
      prive: { s: 30, e: 70, ps: 0.12, pe: 0.15 },
    }
  },
  Y3: {
    startYear: 2028, prix: 7.75, sezzleUp: 0.20, appTx: 0.45,
    ft: { rate: 0.0237, fee: 0.194 }, opex: 810000, traitRatio: 17,
    campRepas: 2200, campPrix: 8.00,
    prov: {
      qc: { s: 800, e: 1050, ps: 0.20, pe: 0.25 },
      on: { s: 600, e: 1100, ps: 0.14, pe: 0.18 },
      ab: { s: 120, e: 400, ps: 0.08, pe: 0.12 },
      prive: { s: 100, e: 250, ps: 0.16, pe: 0.20 },
    }
  },
  Y4: {
    startYear: 2029, prix: 8.00, sezzleUp: 0.20, appTx: 0.55,
    ft: { rate: 0.0243, fee: 0.197 }, opex: 1290000, traitRatio: 55,
    campRepas: 4600, campPrix: 8.00,
    prov: {
      qc: { s: 1100, e: 1300, ps: 0.25, pe: 0.28 },
      on: { s: 1200, e: 2000, ps: 0.18, pe: 0.22 },
      ab: { s: 450, e: 750, ps: 0.14, pe: 0.18 },
      bc: { s: 250, e: 550, ps: 0.08, pe: 0.12 },
      mb: { s: 80, e: 220, ps: 0.06, pe: 0.10 },
      sk: { s: 60, e: 170, ps: 0.06, pe: 0.10 },
      prive: { s: 250, e: 450, ps: 0.18, pe: 0.22 },
    }
  },
  Y5: {
    startYear: 2030, prix: 8.00, sezzleUp: 0.25, appTx: 0.60,
    ft: { rate: 0.0246, fee: 0.198 }, opex: 1765000, traitRatio: 65,
    campRepas: 0, campPrix: 8.00,
    prov: {
      qc: { s: 1350, e: 1400, ps: 0.28, pe: 0.30 },
      on: { s: 2150, e: 2400, ps: 0.22, pe: 0.25 },
      ab: { s: 900, e: 1080, ps: 0.18, pe: 0.22 },
      bc: { s: 700, e: 925, ps: 0.14, pe: 0.18 },
      mb: { s: 255, e: 270, ps: 0.10, pe: 0.12 },
      sk: { s: 190, e: 200, ps: 0.10, pe: 0.12 },
      nb: { s: 50, e: 110, ps: 0.05, pe: 0.10 },
      ne: { s: 60, e: 138, ps: 0.05, pe: 0.10 },
      tnl: { s: 25, e: 88, ps: 0.05, pe: 0.10 },
      ipe: { s: 10, e: 20, ps: 0.05, pe: 0.10 },
      prive: { s: 510, e: 575, ps: 0.22, pe: 0.25 },
    }
  },
};

// ========== OPEX DETAIL ==========
export const opexDetail = {
  pre: { holding: 15000, consultant: 15000, vendeurs: 11250, infra: 4500, incitatifs: 20000, total: 65750 },
  Y1: { holding: 60000, consultant: 60000, aziz: 50000, vendeurs: 45000, infra: 18000, marketing: 6000, comptaLegal: 6000, total: 245000 },
  Y2: { holding: 60000, consultant: 60000, aziz: 50000, lieutenant: 100000, vendeurs: 90000, support: 40000, gestComptes: 50000, infra: 30000, marketing: 20000, comptaLegal: 12000, total: 512000 },
  Y3: { holding: 60000, consultant: 60000, aziz: 50000, lieutenant: 100000, vendeurs: 135000, support: 80000, gestComptes: 150000, coordOps: 50000, infra: 55000, marketing: 50000, comptaLegal: 20000, total: 810000 },
  Y4: { holding: 60000, consultant: 60000, aziz: 50000, lieutenant: 100000, vendeurs: 270000, support: 160000, gestComptes: 300000, coordOps: 55000, infra: 100000, marketing: 100000, comptaLegal: 35000, total: 1290000 },
  Y5: { holding: 60000, consultant: 60000, aziz: 50000, lieutenant: 100000, vendeurs: 405000, support: 240000, gestComptes: 450000, coordOps: 60000, infra: 160000, marketing: 130000, comptaLegal: 50000, total: 1765000 },
};

export const preLaunchBudget = { opex6mois: 150000, incitatifs: 60000, reserve: 40000, total: 250000 };

// ========== GENERATE MONTHLY DATA ==========
function lerp(a, b, t) { return a + (b - a) * t; }

function genSchoolMonth(moisNom, yearKey, monthIdx) {
  const cfg = YEARS[yearKey];
  const t = monthIdx / 9; // 0=Sept(start), 9=Jun(end)
  let totalMeals = 0;
  let totalSchools = 0;
  const provs = cfg.prov;
  for (const p of Object.keys(provs)) {
    const d = provs[p];
    const schools = Math.round(lerp(d.s, d.e, t));
    const part = lerp(d.ps, d.pe, t);
    const epe = EPE[p] || 350;
    totalSchools += schools;
    totalMeals += schools * epe * part;
  }
  const repas = Math.round(totalMeals);
  const gmvReg = repas * JOURS_MOIS_SCOL * cfg.prix;
  const gmvSez = gmvReg * cfg.sezzleUp;
  const parents = repas / ENFANTS_PAR_PARENT;
  const checks = parents * CHECK_PAR_PARENT;
  const traiteurs = Math.max(TRAITEURS_INIT, Math.round(totalSchools / cfg.traitRatio));
  const revFT = gmvReg * cfg.ft.rate;
  const revSez = gmvSez * SEZZLE_NET;
  const revFee = checks * cfg.ft.fee;
  const revApp = parents * cfg.appTx * APP_PRIX_NET;
  const revSaaS = Math.max(0, traiteurs - TRAITEURS_INIT) * SAAS_PRIX;
  const revenus = revFT + revSez + revFee + revApp + revSaaS;
  const opex = cfg.opex / 12;
  return {
    mois: moisNom, repasReguliers: repas, gmvRegulier: Math.round(gmvReg),
    gmvSezzle: Math.round(gmvSez), revenus: Math.round(revenus),
    opexTotal: Math.round(opex), baiia: Math.round(revenus - opex),
    ecolesTotal: totalSchools, traiteurs,
  };
}

function genSummerMonth(moisNom, yearKey) {
  const cfg = YEARS[yearKey];
  const camp = cfg.campRepas;
  const opex = cfg.opex / 12;
  if (!camp) {
    return { mois: moisNom, repasReguliers: 0, gmvRegulier: 0, gmvSezzle: 0, revenus: 0, opexTotal: Math.round(opex), baiia: Math.round(-opex), ecolesTotal: 0, traiteurs: 0 };
  }
  const gmvReg = camp * JOURS_ETE_MOIS * cfg.campPrix;
  const gmvSez = gmvReg * cfg.sezzleUp;
  const parents = camp / ENFANTS_PAR_PARENT;
  const checks = parents * CHECK_PAR_PARENT;
  const revFT = gmvReg * cfg.ft.rate;
  const revSez = gmvSez * SEZZLE_NET;
  const revFee = checks * cfg.ft.fee;
  const revApp = parents * cfg.appTx * APP_PRIX_NET;
  const revenus = revFT + revSez + revFee + revApp;
  return {
    mois: moisNom, repasReguliers: camp, gmvRegulier: Math.round(gmvReg),
    gmvSezzle: Math.round(gmvSez), revenus: Math.round(revenus),
    opexTotal: Math.round(opex), baiia: Math.round(revenus - opex),
    ecolesTotal: 0, traiteurs: 0,
  };
}

function genYear(yearKey) {
  const sy = YEARS[yearKey].startYear;
  const sm = ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
  const months = [];
  for (let i = 0; i < 10; i++) {
    const yr = i <= 3 ? sy : sy + 1;
    months.push(genSchoolMonth(`${sm[i]} ${yr}`, yearKey, i));
  }
  months.push(genSummerMonth(`Jul ${sy + 1}`, yearKey));
  months.push(genSummerMonth(`Aug ${sy + 1}`, yearKey));
  return months;
}

function genPreLaunch() {
  const opexMois = Math.round(opexDetail.pre.total / 3);
  const camp = 150;
  const prix = 7.25;
  const months = [];
  months.push({ mois: 'Jun 2026', repasReguliers: 0, gmvRegulier: 0, gmvSezzle: 0, revenus: 0, opexTotal: opexMois, baiia: -opexMois, ecolesTotal: 0, traiteurs: 0 });
  for (const m of ['Jul 2026', 'Aug 2026']) {
    const gmvReg = camp * JOURS_ETE_MOIS * prix;
    const gmvSez = gmvReg * 0.18;
    const parents = camp / ENFANTS_PAR_PARENT;
    const checks = parents * CHECK_PAR_PARENT;
    const rev = gmvReg * 0.015 + gmvSez * SEZZLE_NET + checks * 0.15 + parents * 0.25 * APP_PRIX_NET;
    months.push({ mois: m, repasReguliers: camp, gmvRegulier: Math.round(gmvReg), gmvSezzle: Math.round(gmvSez), revenus: Math.round(rev), opexTotal: opexMois, baiia: Math.round(rev - opexMois), ecolesTotal: 0, traiteurs: 0 });
  }
  return months;
}

// ========== ASSEMBLE ==========
export const financialData = {
  'Pre-launch': genPreLaunch(),
  'Y1 (2026-27)': genYear('Y1'),
  'Y2 (2027-28)': genYear('Y2'),
  'Y3 (2028-29)': genYear('Y3'),
  'Y4 (2029-30)': genYear('Y4'),
  'Y5 (2030-31)': genYear('Y5'),
};

// ========== TOTAUX ANNUELS ==========
export const yearlyTotals = Object.entries(financialData).map(([key, data]) => ({
  annee: key,
  gmvRegulier: data.reduce((s, m) => s + m.gmvRegulier, 0),
  gmvSezzle: data.reduce((s, m) => s + m.gmvSezzle, 0),
  revenus: data.reduce((s, m) => s + m.revenus, 0),
  opexTotal: data.reduce((s, m) => s + m.opexTotal, 0),
  baiia: data.reduce((s, m) => s + m.baiia, 0),
  gmv: data.reduce((s, m) => s + m.gmvRegulier + m.gmvSezzle, 0),
}));

// ========== SCENARIOS Y1 ==========
export const scenariosY1 = [10, 15, 20].map(pct => {
  const p = pct / 100;
  const repas = Math.round(70000 * p);
  const parents = repas / ENFANTS_PAR_PARENT;
  const checks = parents * CHECK_PAR_PARENT;
  const gmv = repas * 180 * 7.25;
  const gmvSez = gmv * 0.18;
  const rev = gmv * 0.015 + gmvSez * SEZZLE_NET + checks * 0.15 * 10 + parents * 0.25 * APP_PRIX_NET * 10;
  return { label: `${pct}%`, pct, repas, parents: Math.round(parents), gmv: Math.round(gmv), gmvSezzle: Math.round(gmvSez), revenus: Math.round(rev), opex: 245000, baiia: Math.round(rev - 245000) };
});

// ========== VALORISATION ==========
export const VALORISATION_MULTIPLES = {
  Y1: 12, Y2: 15, Y3: 18, Y4: 22, Y5: 26, Y6: 30, Y7: 33
};
export const LICORNE_YEAR = 'Y6';

const valorisationBase = [
  { annee: 'Y1', multiple: VALORISATION_MULTIPLES.Y1 },
  { annee: 'Y2', multiple: VALORISATION_MULTIPLES.Y2 },
  { annee: 'Y3', multiple: VALORISATION_MULTIPLES.Y3 },
  { annee: 'Y4', multiple: VALORISATION_MULTIPLES.Y4 },
  { annee: 'Y5', multiple: VALORISATION_MULTIPLES.Y5 },
].map(v => {
  const yt = yearlyTotals.find(y => y.annee.startsWith(v.annee));
  const rev = yt ? yt.revenus : 0;
  return { ...v, revenus: rev, valeur: rev * v.multiple };
});

// Extrapolation Y6-Y7 (vers Licorne)
const lastYtRev = yearlyTotals.length > 0 ? yearlyTotals[yearlyTotals.length - 1].revenus : 0;
const y6Rev = Math.round(lastYtRev * 1.35);
const y7Rev = Math.round(y6Rev * 1.30);
export const valorisation = [
  ...valorisationBase,
  { annee: 'Y6', multiple: VALORISATION_MULTIPLES.Y6, revenus: y6Rev, valeur: y6Rev * VALORISATION_MULTIPLES.Y6 },
  { annee: 'Y7', multiple: VALORISATION_MULTIPLES.Y7, revenus: y7Rev, valeur: y7Rev * VALORISATION_MULTIPLES.Y7 },
];

// ========== EXPANSION & PARTICIPATION (pour affichage) ==========
export const expansionProvince = {
  Y1: { qc: 200 },
  Y2: { qc: 450, on: 150, prive: 30 },
  Y3: { qc: 800, on: 600, ab: 120, prive: 100 },
  Y4: { qc: 1100, on: 1200, ab: 450, bc: 250, mb: 80, sk: 60, prive: 250 },
  Y5: { qc: 1400, on: 2400, ab: 1080, bc: 925, mb: 270, sk: 200, nb: 110, ne: 138, tnl: 88, ipe: 20, prive: 575 },
};

export const participationProvince = {
  Y1: { qc: 0.15 },
  Y2: { qc: 0.20, on: 0.12, prive: 0.15 },
  Y3: { qc: 0.25, on: 0.18, ab: 0.12, prive: 0.20 },
  Y4: { qc: 0.28, on: 0.22, ab: 0.18, bc: 0.12, mb: 0.10, sk: 0.10, prive: 0.22 },
  Y5: { qc: 0.30, on: 0.25, ab: 0.22, bc: 0.18, mb: 0.12, sk: 0.12, nb: 0.10, ne: 0.10, tnl: 0.10, ipe: 0.10, prive: 0.25 },
};

export const objectifs = {
  qc: 1400, on: 2400, ab: 1080, bc: 925, mb: 270, sk: 200,
  nb: 110, ne: 138, tnl: 88, ipe: 20, prive: 575, total: 7206,
};

export const planContent = {};

// =============================================================
// ========== NOUVEAU PLAN — PRÉ-SEED 500K Y1 ===================
// =============================================================
// Toutes les nouvelles données refletant le plan complet d'affaires
// orienté pré-seed 500K + GTM écoles + garderies + ronde seed Fév

// ========== INVESTISSEMENT PRE-SEED ==========
export const preSeedInvestment = {
  total: 500000,
  equity: 0.10, // ~10%
  duration: 6, // mois (Sept-Février)
  useOfFunds: {
    gtm: 350000,
    development: 48000,
    ledger: 10000,
    legal: 15000,
    marketing: 10000,
    reserve: 67000,
  },
};

// ========== TRACTION ACTUELLE (proof of concept) ==========
export const tractionActuelle = {
  traiteurs: 6,
  ecoles: 73,
  garderies: 51,
  etablissements: 124, // 73 + 51
  duree: 'moins d\'un mois',
  dureeEn: 'less than one month',
};

// ========== TAM CONSOLIDÉ ==========
export const TAM_ECOLES_NEW = 12700;
export const ELEVES_PAR_ECOLE = 350;
export const PARTICIPATION_ECOLE = 0.10;
export const REPAS_PAR_ECOLE_JOUR = 35; // 350 * 10%
export const PRIX_REPAS_ECOLE = 7;
export const JOURS_ECOLE = 180;
export const GMV_ECOLE_ANNUEL = 44100; // 35 * 7 * 180

export const TAM_GARDERIES_PLACES = 750230;
export const RATIO_GARDERIE_EXTERNE = 0.572;
export const TAM_GARDERIES_PLACES_EXTERNE = Math.round(TAM_GARDERIES_PLACES * RATIO_GARDERIE_EXTERNE);
export const ENFANTS_PAR_GARDERIE = 50;
export const PARTICIPATION_GARDERIE = 1.0;
export const REPAS_PAR_GARDERIE_JOUR = 50;
export const PRIX_REPAS_GARDERIE = 6;
export const JOURS_GARDERIE = 261;
export const GMV_GARDERIE_ANNUEL = 78300; // 50 * 6 * 261

// TAM GMV potentiel
export const TAM_GMV_ECOLES = 560100000; // 444 500 repas/jour x 7$ x 180 jours
export const TAM_GMV_GARDERIES = 672000000; // ~672M$

// ========== TRAITEURS-EQUIVALENTS ==========
export const ETABLISSEMENTS_PAR_TRAITEUR = 15;
export const TRAITEURS_EQUIV_ECOLES = 847; // 12700 / 15
export const TRAITEURS_EQUIV_GARDERIES = 572; // 429132 / 50 / 15
export const TRAITEURS_EQUIV_TOTAL = 1419;

// ========== STRUCTURE COMMERCIALE 6 MOIS ==========
export const equipeCommerciale = {
  vendeurs: 3,
  closer: 1,
  directeurVentes: 'Dan',
  leadProvider: 'Rox',
  supportOnboarding: 'MC / Phil',
  cadenceParVendeur: 5, // traiteurs/mois
  totalTraiteurs6Mois: 90, // 3 × 5 × 6
};

// ========== MODÈLE DE REVENUS — TIERED ==========
export const tarification = {
  tier1: { // 1-25 traiteurs
    label: '1 à 25 traiteurs',
    labelEn: '1 to 25 caterers',
    fraisEcolunch: { pct: 0.029, fixe: 0.30 },
    coutPaiement: { pct: 0.017, fixe: 0.18 },
    margeNette: { pct: 0.012, fixe: 0.12 },
    saas: 0,
  },
  tier2: { // 26+
    label: '26+ traiteurs',
    labelEn: '26+ caterers',
    fraisEcolunch: { pct: 0.039, fixe: 0.30 },
    coutPaiement: { pct: 0.017, fixe: 0.18 },
    margeNette: { pct: 0.022, fixe: 0.12 },
    saas: 150, // $/mois minimum
  },
};

// ========== ABONNEMENT PARENT OPTIONNEL ==========
export const abonnementParent = {
  prix: 2, // $/mois brut
  donationEcoles: 0.50, // 50% reverse en don aux écoles
  netEcolunch: 1, // $/mois net (50% de 2$)
  adoptionParents: 0.25,
  enfantsParCompte: 1.6,
  lancementMois: 2, // fin M2
  revenusDebut: 3, // à partir de M3
};

// ========== UNIT ECONOMICS (annuels) ==========
export const unitEconomicsEcole = {
  repasJour: 35,
  gmvAnnuel: 44100,
  transactionsAnnuelles: 1102.5,
  tier1: { transactionnel: 662, parentSaaS: 488, total: 1150 },
  tier2: { transactionnel: 1103, parentSaaS: 488, total: 1591 },
};

export const unitEconomicsGarderie = {
  repasJour: 50,
  gmvAnnuel: 78300,
  transactionsAnnuelles: 52, // 1 commande/semaine
  commandeMoyenne: 1506,
  tier1: { transactionnel: 946, parentSaaS: 0, total: 946 },
  tier2: { transactionnel: 1729, parentSaaS: 0, total: 1729 },
};

export const unitEconomicsParTraiteur = [
  { type: '15 écoles', typeEn: '15 schools', repasJour: 525, gmvAnnuel: 661500, tier1: 17300, tier2: 25700 },
  { type: '15 garderies', typeEn: '15 daycares', repasJour: 750, gmvAnnuel: 1174500, tier1: 14200, tier2: 27700 },
  { type: '15 écoles + 15 garderies', typeEn: '15 schools + 15 daycares', repasJour: 1275, gmvAnnuel: 1836000, tier1: 31400, tier2: 51600 },
];

// ========== OBJECTIFS Y1 — 2 SCÉNARIOS ==========
export const objectifsY1 = {
  minimum: {
    label: 'Minimum',
    m6: { ecoles: 500, garderies: 500, etablissements: 1000, repasJour: 42500, gmvAnnualise: 61200000 },
    m12: { ecoles: 1000, garderies: 1000, etablissements: 2000, repasJour: 85000, gmvAnnualise: 122400000 },
    revenuAnnualiseM12: 3380000,
  },
  realiste: {
    label: 'Réaliste',
    m6: { ecoles: 750, garderies: 750, etablissements: 1500, repasJour: 63750, gmvAnnualise: 91800000 },
    m12: { ecoles: 1500, garderies: 1500, etablissements: 3000, repasJour: 127500, gmvAnnualise: 183600000 },
    revenuAnnualiseM12: 5210000,
  },
};

// ========== PRÉVISIONS MENSUELLES Y1 — Scénarios ==========
// Données exactes du plan d'affaires (12 mois Sept → Août)
const moisLabels = [
  { fr: 'Sept. M1', en: 'Sep. M1' },
  { fr: 'Oct. M2', en: 'Oct. M2' },
  { fr: 'Nov. M3', en: 'Nov. M3' },
  { fr: 'Déc. M4', en: 'Dec. M4' },
  { fr: 'Jan. M5', en: 'Jan. M5' },
  { fr: 'Fév. M6', en: 'Feb. M6' },
  { fr: 'Mars M7', en: 'Mar. M7' },
  { fr: 'Avr. M8', en: 'Apr. M8' },
  { fr: 'Mai M9', en: 'May M9' },
  { fr: 'Juin M10', en: 'Jun. M10' },
  { fr: 'Juil. M11', en: 'Jul. M11' },
  { fr: 'Août M12', en: 'Aug. M12' },
];

export const previsionsY1Minimum = [
  { mois: 0, ecoles: 73, garderies: 51, etablissements: 124, traiteurs: 8, repasJour: 5105, gmvAnnualise: 7200000, revenuMensuel: 8000, depenses: 83300, resultat: -75300, cash: 424700 },
  { mois: 1, ecoles: 158, garderies: 141, etablissements: 299, traiteurs: 20, repasJour: 12580, gmvAnnualise: 18000000, revenuMensuel: 19800, depenses: 83300, resultat: -63500, cash: 361200 },
  { mois: 2, ecoles: 244, garderies: 231, etablissements: 475, traiteurs: 32, repasJour: 20090, gmvAnnualise: 28800000, revenuMensuel: 49600, depenses: 83300, resultat: -33700, cash: 327500 },
  { mois: 3, ecoles: 329, garderies: 320, etablissements: 649, traiteurs: 43, repasJour: 27515, gmvAnnualise: 39600000, revenuMensuel: 76100, depenses: 83300, resultat: -7200, cash: 320300 },
  { mois: 4, ecoles: 415, garderies: 410, etablissements: 825, traiteurs: 55, repasJour: 35025, gmvAnnualise: 50400000, revenuMensuel: 102900, depenses: 83300, resultat: 19600, cash: 339900 },
  { mois: 5, ecoles: 500, garderies: 500, etablissements: 1000, traiteurs: 67, repasJour: 42500, gmvAnnualise: 61200000, revenuMensuel: 129500, depenses: 83300, resultat: 46200, cash: 386100, milestone: 'M6' },
  { mois: 6, ecoles: 583, garderies: 583, etablissements: 1166, traiteurs: 78, repasJour: 49555, gmvAnnualise: 71400000, revenuMensuel: 154800, depenses: 66300, resultat: 88500, cash: 474600 },
  { mois: 7, ecoles: 667, garderies: 667, etablissements: 1334, traiteurs: 89, repasJour: 56695, gmvAnnualise: 81600000, revenuMensuel: 180500, depenses: 66300, resultat: 114100, cash: 588700 },
  { mois: 8, ecoles: 750, garderies: 750, etablissements: 1500, traiteurs: 100, repasJour: 63750, gmvAnnualise: 91800000, revenuMensuel: 205800, depenses: 66300, resultat: 139400, cash: 728100 },
  { mois: 9, ecoles: 833, garderies: 833, etablissements: 1666, traiteurs: 111, repasJour: 70805, gmvAnnualise: 102000000, revenuMensuel: 231100, depenses: 66300, resultat: 164700, cash: 892900 },
  { mois: 10, ecoles: 917, garderies: 917, etablissements: 1834, traiteurs: 122, repasJour: 77945, gmvAnnualise: 112200000, revenuMensuel: 256700, depenses: 66300, resultat: 190300, cash: 1080000 },
  { mois: 11, ecoles: 1000, garderies: 1000, etablissements: 2000, traiteurs: 134, repasJour: 85000, gmvAnnualise: 122400000, revenuMensuel: 282000, depenses: 66300, resultat: 215600, cash: 1300000, milestone: 'M12' },
].map((d, i) => ({ ...d, label: moisLabels[i].fr, labelEn: moisLabels[i].en }));

export const previsionsY1Realiste = [
  { mois: 0, ecoles: 73, garderies: 51, etablissements: 124, traiteurs: 8, repasJour: 5105, gmvAnnualise: 7200000, revenuMensuel: 8000, depenses: 83300, resultat: -75300, cash: 424700 },
  { mois: 1, ecoles: 208, garderies: 191, etablissements: 399, traiteurs: 27, repasJour: 16830, gmvAnnualise: 24100000, revenuMensuel: 28000, depenses: 83300, resultat: -55400, cash: 369400 },
  { mois: 2, ecoles: 344, garderies: 331, etablissements: 675, traiteurs: 45, repasJour: 28590, gmvAnnualise: 41100000, revenuMensuel: 80100, depenses: 83300, resultat: -3200, cash: 366100 },
  { mois: 3, ecoles: 479, garderies: 470, etablissements: 949, traiteurs: 63, repasJour: 40265, gmvAnnualise: 57900000, revenuMensuel: 121800, depenses: 83300, resultat: 38500, cash: 404600 },
  { mois: 4, ecoles: 615, garderies: 610, etablissements: 1225, traiteurs: 82, repasJour: 52025, gmvAnnualise: 74900000, revenuMensuel: 163900, depenses: 83300, resultat: 80500, cash: 485100 },
  { mois: 5, ecoles: 750, garderies: 750, etablissements: 1500, traiteurs: 100, repasJour: 63750, gmvAnnualise: 91800000, revenuMensuel: 205800, depenses: 83300, resultat: 122400, cash: 607500, milestone: 'M6' },
  { mois: 6, ecoles: 875, garderies: 875, etablissements: 1750, traiteurs: 117, repasJour: 74375, gmvAnnualise: 107100000, revenuMensuel: 243900, depenses: 66300, resultat: 177500, cash: 785100 },
  { mois: 7, ecoles: 1000, garderies: 1000, etablissements: 2000, traiteurs: 134, repasJour: 85000, gmvAnnualise: 122400000, revenuMensuel: 282000, depenses: 66300, resultat: 215600, cash: 1000000 },
  { mois: 8, ecoles: 1125, garderies: 1125, etablissements: 2250, traiteurs: 150, repasJour: 95625, gmvAnnualise: 137700000, revenuMensuel: 320100, depenses: 66300, resultat: 253700, cash: 1250000 },
  { mois: 9, ecoles: 1250, garderies: 1250, etablissements: 2500, traiteurs: 167, repasJour: 106250, gmvAnnualise: 153000000, revenuMensuel: 358200, depenses: 66300, resultat: 291800, cash: 1550000 },
  { mois: 10, ecoles: 1375, garderies: 1375, etablissements: 2750, traiteurs: 184, repasJour: 116875, gmvAnnualise: 168300000, revenuMensuel: 396300, depenses: 66300, resultat: 329900, cash: 1880000 },
  { mois: 11, ecoles: 1500, garderies: 1500, etablissements: 3000, traiteurs: 200, repasJour: 127500, gmvAnnualise: 183600000, revenuMensuel: 434400, depenses: 66300, resultat: 368100, cash: 2240000, milestone: 'M12' },
].map((d, i) => ({ ...d, label: moisLabels[i].fr, labelEn: moisLabels[i].en }));

// ========== PÉNÉTRATION TAM ==========
export const penetrationTAM = [
  { scenario: 'Minimum M6', ecoles: 500, pctEcoles: 0.039, garderies: 500, places: 25000, pctGarderiesTotal: 0.033, pctGarderiesExterne: 0.058, pctTraiteurs: 0.047 },
  { scenario: 'Minimum M12', ecoles: 1000, pctEcoles: 0.079, garderies: 1000, places: 50000, pctGarderiesTotal: 0.067, pctGarderiesExterne: 0.117, pctTraiteurs: 0.094 },
  { scenario: 'Réaliste M6', ecoles: 750, pctEcoles: 0.059, garderies: 750, places: 37500, pctGarderiesTotal: 0.050, pctGarderiesExterne: 0.087, pctTraiteurs: 0.070 },
  { scenario: 'Réaliste M12', ecoles: 1500, pctEcoles: 0.118, garderies: 1500, places: 75000, pctGarderiesTotal: 0.100, pctGarderiesExterne: 0.175, pctTraiteurs: 0.141 },
];

